/**
 * Created by JIA on 2017/11/1.
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, TouchableOpacity, TouchableWithoutFeedback, View } from "react-native";
import { Icon } from "native-base";

import { AppColors, AppSizes, AppStyles } from "../../theme/";

import * as Helper from "../../utils/Helper";
/**
 * See example at ./examples/jia/index.js
 */

/*Header Body Footer Components*/
const Header = (props, context) => {
    return (
        <View
            style={[
                AppStyles.row,
                AppStyles.paddingVerticalXs,
                AppStyles.paddingHorizontalSml,
                AppStyles.justifyContentCenter,
                {
                    borderTopLeftRadius: 2,
                    borderTopRightRadius: 2,
                    backgroundColor: AppColors.background
                },
                props.style
            ]}
        >
            {props.showCloseButton
                ? <View style={[AppStyles.paddingRightSml, AppStyles.flex1]}>
                      {props.children}
                  </View>
                : props.children}
            {props.showCloseButton
                ? <TouchableOpacity onPress={context.closeFunc} style={[AppStyles.rightAligned, AppStyles.justifyContentCenter, { width: 20 }]}>
                      <Icon muted xs name="md-close" />
                  </TouchableOpacity>
                : null}
        </View>
    );
};
Header.propTypes = {
    ...View.propTypes,
    showCloseButton: PropTypes.bool
};

Header.defaultProps = {
    showCloseButton: true
};
Header.contextTypes = { closeFunc: PropTypes.func };

const Body = props => {
    return <View style={[AppStyles.paddingSml, AppStyles.justifyContentCenter, props.style]}>{props.children}</View>;
};
const Footer = props => {
    return (
        <View
            removeClippedSubviews={true}
            style={[
                AppStyles.row,
                {
                    borderBottomLeftRadius: 2,
                    borderBottomRightRadius: 2,
                },
                props.style
            ]}
        >
            {props.children}
        </View>
    );
};

class Dialog extends Component {
    getChildContext() {
        return { closeFunc: this._close };
    }
    constructor(props) {
        super(props);

        this.state = {
            modalVisible: false
        };
    }

    show() {
        this._open();
    }

    hide() {
        this._close();
    }

    toggle() {
        if (this.state.modalVisible) {
            this._close();
        } else {
            this._open();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.visible !== this.state.modalVisible) {
            this.setState({ modalVisible: nextProps.visible });
        }
    }

    componentWillUnmount() {
        this._setCloseState();
    }

    render() {
        const modalBackgroundStyle = {
            backgroundColor: this.props.transparent ? "rgba(0, 0, 0, 0.7)" : "#f5fcff"
        };

        const innerContainerTransparentStyle = this.props.transparent ? [AppStyles.bgColorWhite100, { width: Helper.getContainerSize().width - 30 }] : null;
        return (
            <Modal
                transparent={this.props.transparent}
                ref="modal"
                visible={this.state.modalVisible}
                onRequestClose={this._close}
                animationType={this.props.animationType}
            >
                {/* fix bug AIC-1-368: app端 提交答案弹出的确认框 背景是灰色 */}
                {/* <Container transparent> */}
                    <TouchableWithoutFeedback onPress={this._onPressOutSide}>
                        <View style={[AppStyles.flex1, AppStyles.centerAligned, modalBackgroundStyle]}>
                            <View style={AppStyles.paddingHorizontal}>
                                {/*make the inner part click event do not bubble up to trigger the _onPressOutSide*/}
                                <TouchableWithoutFeedback onPress={(event)=>{event.stopPropagation();}}>
                                    <View style={[AppStyles.bgColorWhite100, innerContainerTransparentStyle, { borderRadius: 2 }]} >
                                        {this.props.children}
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>
                        </View>
                    </TouchableWithoutFeedback>
                {/* </Container> */}
            </Modal>
        );
    }

    _setCloseState = () => {
        this.setState({
            modalVisible: false
        });
    };

    _close = () => {
        this.setState({
            modalVisible: false
        });
    };

    _open = () => {
        this.setState({
            modalVisible: true
        });
    };

    _onPressOutSide = () => {
        if(this.props.closeWhenTapOutside){
            this.hide();
            if(this.props.tapOutsideCloseCallBack){
                this.props.tapOutsideCloseCallBack();
            }
        }
    }
}

Dialog.propTypes = {
    //...Modal.propTypes,

    animationType: PropTypes.oneOf(["none", "slide", "fade"]),
    transparent: PropTypes.bool,
    visible: PropTypes.bool,
    closeWhenTapOutside: PropTypes.bool,
    tapOutsideCloseCallBack: PropTypes.func
};

Dialog.defaultProps = {
    animationType: "fade", // use other animation type will have bug
    transparent: true,
    visible: false,
    closeWhenTapOutside: false,
    tapOutsideCloseCallBack: ()=>{}
};
Dialog.childContextTypes = {
    closeFunc: PropTypes.func
};

Dialog.Header = Header;
Dialog.Body = Body;
Dialog.Footer = Footer;

export default Dialog;
